import camelCase from 'camel-case'

/**
 * Camelizes a single key exactly the way `toCamelCase` does.
 *
 * Use it to look up a value the backend keyed by a string the transform mangles, e.g. an add-on id
 * (`addon-images-50` becomes `addonImages_50`).
 *
 * @param {string} key
 * @returns {string}
 */
export function camelizeKey(key: string): string {
  return camelCase(key)
}

/**
 * Deeply camelizes the object
 *
 * @param {Record<string, any>} obj
 * @returns {Record<string, any>}
 */
export function toCamelCase(obj: Record<string, any>): Record<string, any>
export function toCamelCase(obj: undefined): undefined
export function toCamelCase(obj: null): null
export function toCamelCase(obj: number): number
export function toCamelCase(obj: string): string
export function toCamelCase(
  obj: Record<string, any> | undefined | null | number | string
): Record<string, any> | undefined | null | number | string {

  if (!obj || typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean') {
    return obj
  }

  // Camelize each value
  if (Array.isArray(obj)) {
    return obj.map(toCamelCase) as Record<string, any>
  }

  // Camelize the keys and call for each value
  return Object.keys(obj).reduce((result, key) => {
    const camelKey = camelCase(key)
    result[camelKey] = toCamelCase(obj[key])
    return result
  }, {} as Record<string, any>)
}

export default toCamelCase
